import { FeedIcon } from '@modules/common/components/FeedIcon';
import {
  CollectionsBookmarkRounded,
  InsightsRounded,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';

export const getAnalysisIcon = (
  useCase: AnalysisUseCase,
  svgIconProps?: SvgIconProps,
) => {
  switch (useCase) {
    case AnalysisUseCase.Feed:
      return <FeedIcon {...svgIconProps} />;
    case AnalysisUseCase.Collection:
      return <CollectionsBookmarkRounded {...svgIconProps} />;
    default:
      return <InsightsRounded {...svgIconProps} />;
  }
};
